
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 70"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","stroke":"#FFF","stroke-width":"2","d":"M139 1v68H1V1h138z"}}),_c('g',{attrs:{"fill":"#FFCA05"}},[_c('path',{attrs:{"d":"M11.375 14h18.211v8.405h-7.289v7.964h6.822v7.99h-6.822v9.236h8.016V56H11.375zm44.096 0l-3.84 18.574L57.416 56H47.299c-1.21-4.187-2.317-9.29-3.32-15.305a139.37 139.37 0 01-1.153 8.457L41.799 56H31.163l3.969-23.426L31.162 14h10.56c.191 1.157.57 3.084 1.137 5.783.458 2.056.831 3.951 1.12 5.683L46.312 14h9.158z"}}),_c('path',{attrs:{"d":"M80.943 14l-3.84 18.574L82.89 56H72.771c-1.208-4.187-2.316-9.29-3.32-15.305a137.768 137.768 0 01-1.152 8.457L67.272 56H56.636l3.969-23.426L56.635 14h10.56c.19 1.157.57 3.084 1.138 5.783.457 2.056.83 3.951 1.118 5.683L71.785 14h9.158zm2.527 0h18.211v8.405h-7.29v7.964h6.823v7.99h-6.823v9.236h8.017V56H83.47zm45.27 0v42h-9.573l-5.681-19.093V56h-9.132V14h9.132l6.122 18.912V14z"}})]),_c('path',{attrs:{"fill":"#000","d":"M87.525 38.182h6.765v-7.953h-6.765z"}})])])
          )
        }
      }
    